// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/umweltpakt-bayern-2-2-2-2-3/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const umweltpaktBayern22223DE: PageEntry = {
  id: "post.umweltpakt-bayern-2-2-2-2-3",
  locale: "de",
  slug: "umweltpakt-bayern-2-2-2-2-3",
  seo: {
    title: "Glückwünsche an unsere Azubis | Dietz GmbH",
    description: "Glückwünsche an unsere Azubis",
  },
  type: "post",
  h1: "Glückwünsche an unsere Azubis",
  blocks: [
    { kind: "heading", level: 2, text: "Glückwünsche an unsere Azubis" },
    { kind: "paragraph", text: "Und wieder einmal hat der Nachwuchs aus unseren eigenen Reihen etwas Großartiges geleistet: Ausbildung bestens bestanden, jetzt geht es ab in ein erfolgreiches Berufsleben!" },
    { kind: "paragraph", text: "Hier sagen wir unseren „fertigen“ Werkzeugmechanikern und Elektronikern noch einmal: Herzlichen Glückwunsch! Und natürlich freuen wir uns, euch auch weiterhin im DIETZ-Team zu haben!" },
    { kind: "paragraph", text: "Wer ebenfalls Interesse an einer Ausbildung oder einem dualen Studium bei uns hat, findet hier alle Infos: https://www.dietz.eu/karriere/schueler/" }
  ],
};
